import React, { useEffect, useState } from "react";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import NotAuthorisedPage from "../notAuthorisedPage";
import ReservationCard from "../../components/Layouts/ReservationsCard/ReservationsCards";
import { t } from "i18next";
import { AppStandardButton } from "../../components/UI/AppButtons";
import BookingGetters from "../../store/onlineBooking/getters";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";

import i18n from "../../config/i18n";
import { useTranslation } from "react-i18next";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";

export default function MyReservedBookings() {
  const AppSettings = BookingGetters.getAppSettings();
  const isSmallScreen = window.innerWidth <= 768;
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;
  const [showReservedBooking, setShowReservedBooking] = useState(false);

  const [showSearchText, setShowSearchText] = useState("");
  const [bookCarData, setBookCarData] = useState("");
  const [showBookingDetailsText, setShowBookingDetailsText] = useState("");
  const { t: translate } = useTranslation();
  const locationLang = i18n.language;

  const textResourceDetails =
    BookingGetters.getTextResourceDetailsBasedOnLang();
  const textResourceData =
    textResourceDetails?.[locationLang]?.flatMap((item) => item.data || []) ||
    [];
  useEffect(() => {
    const bookingCarTextData = textResourceData.find(
      (item) => item.key === "bookCar"
    );

    setBookCarData(bookingCarTextData?.body || t("Book a car"));
    const bookingDetailsTextData = textResourceData.find(
      (item) => item.key === "bookingDetailsText"
    );
    setShowBookingDetailsText(
      bookingDetailsTextData?.body || t("List of reservation")
    );
    const showSearchTextData = textResourceData.find(
      (item) => item.key === "searchBookingText"
    );
    setShowSearchText(showSearchTextData?.body || t("Search reservations"));
  }, [textResourceData, locationLang, translate]);

  const [searchBooking, setSearchBooking] = useState("");

  useEffect(() => {
    setShowReservedBooking(!!AppSettings?.reservedArea);
  }, [AppSettings]);

  const handleSearchBookingValue = (e) => {
    setSearchBooking(e.target.value);
  };

  return (
    <div>
      {showReservedBooking ? (
        <div className="flex-row md:flex">
          {!isSmallScreen && !istabletScreen && (
            <div className="!w-780" style={{ width: "300px" }}>
              <BookingDetalisListSideNavigation />
            </div>
          )}
          {(isSmallScreen || istabletScreen) && (
            <CollapsibleNavbar callFrom="showReservations" />
          )}
          <div
            className="rounded-sm pt-0 md:pt-12"
            style={
              istabletScreen
                ? { width: "100%" }
                : isSmallScreen
                ? { width: "" }
                : { width: "75%" }
            }
          >
            <div
              className={`${
                isSmallScreen ? "p-4" : "px-10"
              } text-[#333] max-w-screen-xl m-auto`}
            >
              {/*<div className=" text-[#333] px-8 max-w-screen-xl m-auto">*/}
              <div className={"flex justify-between"}>
                <p className="text-[24px] font-medium leading-snug">
                  {showBookingDetailsText}
                </p>

                <div className={"flex items-center"}>
                  {!isSmallScreen && (
                    <>
                      <TextField
                        label={showSearchText}
                        variant="outlined"
                        className="mr-4"
                        value={searchBooking}
                        onChange={handleSearchBookingValue}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              style={{ cursor: "pointer" }}
                            >
                              <Search />
                            </InputAdornment>
                          ),
                          style: {
                            height: "40px",
                            borderRadius: "5px",
                            paddingRight: "5px",
                          },
                        }}
                      />

                      {/* <AppStandardButton
                        href="/"
                        className={"ml-4"}
                        variant="contained"
                        style={{
                          width: "150px",
                          marginLeft: "5px",
                          gap: "3px",
                          borderRadius: "10px",
                        }}
                      >
                        <span className="normal-case">{bookCarData}</span>
                      </AppStandardButton> */}
                    </>
                  )}
                  {isSmallScreen && (
                    <AppStandardButton
                      href="/"
                      className={"flex"}
                      variant="contained"
                      style={{
                        width: "150px",
                        marginLeft: "20px",
                        borderRadius: "10px",
                      }}
                    >
                      <span className="normal-case">{bookCarData}</span>
                    </AppStandardButton>
                  )}
                </div>
              </div>
              <p className="text-[#838181] text-[16px]">
                {t("View and manage your bookings.")}
              </p>
            </div>

            {isSmallScreen && (
              <div className="p-4">
                <TextField
                  label={showSearchText}
                  variant="outlined"
                  className="mr-4"
                  value={searchBooking}
                  onChange={handleSearchBookingValue}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ cursor: "pointer" }}
                      >
                        <Search />
                      </InputAdornment>
                    ),
                    style: {
                      height: "40px",
                      borderRadius: "10px",
                      paddingRight: "5px",
                    },
                  }}
                />
              </div>
            )}

            <div className={`p-4 pl-10`}>
              <ReservationCard searchBooking={searchBooking}></ReservationCard>
            </div>
          </div>
        </div>
      ) : (
        <NotAuthorisedPage />
      )}
    </div>
  );
}
